import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useOrderCard = (order) => {
  return useQuery({
    queryKey: ["orderCardState", order],
    queryFn: async () =>
      callApi({
        path: "ordercard",
        command: "get",
        data: JSON.stringify({
          data: { filter: { noFilter: order } },
        }),
      }),
  });
};
